var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-header-content",
    class: {
      'has-title': _vm.title
    }
  }, [_vm.title ? _c('h5', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]) : _vm._e(), _c('button', {
    staticClass: "close-button",
    class: {
      disabled: _vm.closeDisabled
    },
    attrs: {
      "type": "button",
      "disabled": _vm.closeDisabled,
      "aria-label": _vm.$t('close').toString()
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/modal/close-icon.svg"),
      "alt": ""
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }